module.exports = __webpack_public_path__ + "static/media/person_remove.28b05bf2.svg";